import {
  getFirstRenderPartByResource,
  getImageResourceSize,
} from "../../Providers/TemplateInstanceProvider";
import React, { useMemo, useRef } from "react";
import {
  calculateCropRect,
  cropRectToImagePosition,
  getBoxSize,
} from "../../utils";
import useDrag from "../../hooks/useDrag";

import useTemplateInstance from "../../hooks/useTemplateInstance";
import EpmsImage from "../Common/EpmsImage";

const CropImage = ({
  resource,
  template,
  handleCropUpdate,
  scaleRatio,
  handleCropComplete,
  renderPart,
}) => {
  if (!renderPart) {
    renderPart = getFirstRenderPartByResource(resource, template);
  }
  const [state] = useTemplateInstance();

  const scaledRenderPart = useMemo(() => {
    return {
      width: renderPart.size.width * scaleRatio,
      height: renderPart.size.height * scaleRatio,
      x: renderPart.position.x * scaleRatio,
      y: renderPart.position.y * scaleRatio,
    };
  }, [renderPart, scaleRatio]);

  const image = useMemo(() => {
    console.log("The image memo!");
    return {
      width: resource.image.width,
      height: resource.image.height,
      uuid: resource.image.uuid,
    };
  }, [resource.image.uuid]);

  const containerSize = useMemo(() => {
    return { width: scaledRenderPart.width, height: scaledRenderPart.height };
  }, []);

  const startingPosition = useMemo(() => {
    const imageSize = getImageResourceSize(resource.image, renderPart);

    let sr = { ...scaledRenderPart };

    if (renderPart.rotation == 270 || renderPart.rotation == 90) {
      sr.left = scaledRenderPart.top;
      sr.top = scaledRenderPart.left;
      sr.width = scaledRenderPart.height;
      sr.height = scaledRenderPart.width;
    }

    if (resource.image.cropRect) {
      console.log(
        "StartingPosition, already have crop rect!",
        resource.image.cropRect,
        imageSize,
        sr,
        renderPart.image.adaption,
      );
      return cropRectToImagePosition(
        resource.image.cropRect,
        imageSize,
        sr,
        renderPart.image.adaption,
      );
    }

    console.log(
      "Calculating starting positon",
      resource.image,
      imageSize,
      containerSize,
    );
    const pos = getBoxSize(
      renderPart.image.adaption,
      imageSize,
      containerSize,
    );
    // Get crop rect for fill in:
    console.log("StartingPosition: Image size", pos, imageSize, renderPart);
    const cr = calculateCropRect(pos, imageSize, containerSize);
    const sp = cropRectToImagePosition(
      cr,
      imageSize,
      containerSize,
      renderPart.image.adaption,
    );
    console.log("StartingPosition", cr, sp);
    return sp;
  }, [resource.image.rotation, resource.image.uuid, resource.image.cropRect]);

  // FIXME: Rotated images not supported for now. Event positions get reversed
  // etc, so hard to fix:
  if (renderPart.rotation) {
    return null;
  }

  const styles = {
    position: "absolute",
    boxSizing: "border-box",
    width: scaledRenderPart.width + "px",
    height: scaledRenderPart.height + "px",
    top: scaledRenderPart.y + "px",
    left: scaledRenderPart.x + "px",
    border: "none",
  };

  const effect =
    resource.image.overrideEffect || renderPart.image.effect || "original";

  return (
    <div style={styles} className="image-crop-container">
      <Image
        startingPosition={startingPosition}
        handleUpdate={handleCropUpdate}
        handleCropComplete={handleCropComplete}
        image={image}
        containerSize={containerSize}
        containerRotation={renderPart.rotation}
        imageRotation={resource.image.rotation}
        effect={effect}
        adaption={renderPart.image.adaption}
      />
    </div>
  );
};

export default CropImage;

const Image = ({
  startingPosition,
  image,
  containerSize,
  handleUpdate,
  adaption,
  imageRotation,
  containerRotation,
  effect,
  handleCropComplete,
}) => {
  const imageRef = useRef();

  console.log("Crop Starting position", startingPosition, containerSize);
  const options = useMemo(() => {
    let cs = { ...containerSize };
    if (containerRotation == 90 || containerRotation == 270) {
      let tmpw = containerSize.width;
      cs = {
        width: containerSize.height,
        height: tmpw,
      };
    }

    return {
      containerSize: cs,
      onUpdate: handleUpdate,
      onChange: handleCropComplete,
      adaption: adaption,
      rotation: containerRotation,
    };
  }, [containerSize, image]);

  console.log("Dragging with options", startingPosition, options);
  const { picturePosition, eventHandlers, isDragging } = useDrag(
    imageRef,
    startingPosition,
    options,
  );

  console.log("Dragging picture position", picturePosition);

  const imageContainerStyle = {
    width: containerSize.width + "px",
    height: containerSize.height + "px",
    top: 0,
    left: 0,
    position: "absolute",
    opacity: isDragging ? 0.5 : 0,
    boxSizing: "border-box",
    // For some reason, this fixes overflow hidden issue in Safari
    zIndex: 0,
  };

  const borderBox = {
    width: containerSize.width + "px",
    height: containerSize.height + "px",
    top: 0,
    left: 0,
    position: "absolute",
    opacity: isDragging ? 0.5 : 0,
    border: "2px solid black",
    boxSizing: "border-box",
    // For some reason, this fixes overflow hidden issue in Safari
    zIndex: 0,
  };

  console.log("We are dragging?", isDragging);

  const imageStyle = {
    position: "absolute",
    width: picturePosition.width + "px",
    height: picturePosition.height + "px",
    top: picturePosition.y + "px",
    left: picturePosition.x + "px",
    transform: "translateZ(0)",
  };

  if (containerRotation) {
    imageStyle.transform =
      "translateZ(0) rotate(" + containerRotation + "deg)";
  }

  return (
    <>
      <div style={borderBox} />
      <div style={imageContainerStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div ref={imageRef} style={imageStyle} {...eventHandlers}>
            <EpmsImage
              style={{ width: "100%", height: "100%" }}
              uuid={image.uuid}
              effect={effect}
              rotation={imageRotation}
              size={640}
              forceVisible={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};
